export default __webpack_public_path__ + "static/media/about-us-social-care.8da0ca34.jpg";